import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-bootstrap';
import { Form } from 'redux-form';
import { withBreakpoints } from 'react-breakpoints';
import Link from 'components/atoms/buttons/standard/Link';
import ButtonStandardPrimary from 'components/atoms/buttons/standard/Primary';
import FormHeading from 'components/atoms/form/FormHeading';
import { CUSTOM_CHANNEL_MODIFY } from 'constants/capabilities';
import ProtectedComponent from 'hoc/ProtectedComponent';
import GeneralBlock from './General';
import DisplayConfigurationBlock from './DisplayConfiguration';
import AdvancedSettingsBlock from './AdvancedSettings';
import AvailableChannelsBlock from './AvailableChannels';
import ParentEntitiesBlock from './ParentEntities';
import DemoModeBlock from './DemoMode';
import CustomChannelBlock from './CustomChannelList';
import WorkOrderListBlock from './WorkOrderList';

const CustomChannelProtectedComponent = ProtectedComponent({
    requiredCapabilities: [CUSTOM_CHANNEL_MODIFY]
})(CustomChannelBlock);

class EditEntityForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            seededWorkOrder: false
        };
    }

    getEntityId() {
        return this.props.entityId;
    }

    getEntityName() {
        return this.props.entityName;
    }

    renderHeading() {
        if (this.getEntityId()) {
            return (
                <FormHeading>
                    Edit Entity: {this.getEntityName()}
                </FormHeading>
            );
        }

        return (
            <FormHeading>Create New Entity</FormHeading>
        );
    }

    setSeededWorkOrder = value => this.setState({ seededWorkOrder: value })

    render() {
        const {
            formName,
            dispatch,
            breakpoints,
            currentBreakpoint,
            seededSalesforceId,
            metaLoaded,
            handleNewWorkOrder,
            handleNewCustomChannel,
            handleCloneExistingWorkOrder,
            selectedLabelCode,
            handleOverrideRemoval,
            selectedProgrammaticObjective,
            switchWorkOrderPlatforms,
            selectedBrandId,
            selectOverrideBrandAdvancedOptions,
            selectOverrideBrandDisplayConfiguration
        } = this.props;

        const { seededWorkOrder } = this.state;
        if (seededSalesforceId && metaLoaded && !seededWorkOrder) {
            this.setSeededWorkOrder(true);
            this.props.handleNewWorkOrder({
                adminPlatform: 'salesforce',
                meta: {},
                new: true,
                salesforceId: seededSalesforceId
            });
        }

        const movableBlock = (<React.Fragment>
            <Row>
                <Col md={8}>
                    <ParentEntitiesBlock entityId={this.getEntityId()} />
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <DemoModeBlock />
                </Col>
            </Row>
        </React.Fragment>
        );

        const showMovableBlockInFirstColumn = breakpoints[currentBreakpoint] >= breakpoints.md;

        return (
            <Form onSubmit={this.props.handleSubmit()} id="editEntityForm">
                <Grid fluid>
                    {this.renderHeading()}
                    <Row>
                        <Col md={6}>
                            <GeneralBlock selectedBrandId={selectedBrandId} />
                            <WorkOrderListBlock
                                dispatch={dispatch}
                                formName={formName}
                                handleNewWorkOrder={handleNewWorkOrder}
                                handleCloneExistingWorkOrder={handleCloneExistingWorkOrder}
                                handleOverrideRemoval={handleOverrideRemoval}
                                switchWorkOrderPlatforms={switchWorkOrderPlatforms}
                            />
                            <CustomChannelProtectedComponent
                                dispatch={dispatch}
                                formName={formName}
                                handleNewCustomChannel={handleNewCustomChannel}
                            />
                            {showMovableBlockInFirstColumn && movableBlock}
                        </Col>
                        <Col md={6}>
                            <DisplayConfigurationBlock
                                selectedBrandId={selectedBrandId}
                                selectedProgrammaticObjective={selectedProgrammaticObjective}
                                selectedLabelCode={selectedLabelCode}
                                selectOverrideBrandDisplayConfiguration={selectOverrideBrandDisplayConfiguration}
                            />
                            <AdvancedSettingsBlock
                                selectedBrandId={selectedBrandId}
                                selectOverrideBrandAdvancedOptions={selectOverrideBrandAdvancedOptions} />
                            <AvailableChannelsBlock
                                selectedBrandId={selectedBrandId}
                                selectOverrideBrandAdvancedOptions={selectOverrideBrandAdvancedOptions} />

                            {!showMovableBlockInFirstColumn && movableBlock}
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={4}>
                            <br />
                            <ButtonStandardPrimary type="submit">{this.getEntityId() ? 'Save Changes' : 'Create Entity'}</ButtonStandardPrimary>
                            <Link onClick={this.props.handleCancel}>Cancel</Link>
                        </Col>
                    </Row>
                </Grid>
            </Form>
        );
    }
}

EditEntityForm.propTypes = {
    entityId: PropTypes.number,
    entityName: PropTypes.string,
    formName: PropTypes.string,
    dispatch: PropTypes.func,
    handleSubmit: PropTypes.func,
    handleCancel: PropTypes.func,
    handleNewWorkOrder: PropTypes.func,
    handleNewCustomChannel: PropTypes.func,
    handleCloneExistingWorkOrder: PropTypes.func,
    handleOverrideRemoval: PropTypes.func,
    switchWorkOrderPlatforms: PropTypes.func,
    selectedOverrideBrandEnabledChannels: PropTypes.bool,
    selectOverrideBrandAdvancedOptions: PropTypes.bool,
    selectOverrideBrandDisplayConfiguration: PropTypes.bool,
    selectedProgrammaticObjective: PropTypes.string,
    selectedLabelCode: PropTypes.string,
    breakpoints: PropTypes.object, // provided by withBreakpoints HOC
    currentBreakpoint: PropTypes.string, // provided by withBreakpoints HOC
};

export default withBreakpoints(EditEntityForm);



// WEBPACK FOOTER //
// ./src/components/organisms/entity/edit/Form.js